import { createTheme } from "@mui/material/styles";

export const colors = {
  primary: "#123051",
  secondary: "#99439D",
  black: "#0F0F0F",
  white: "#ffffff",
  textGrey: "#6B6F80",
  textSecondary: "#00000099",
  background: "#F6F7F9",
  borderColor: "#3b3b3b",
  lightGrey: "#BBBBBB",
  mediumGrey: "#9A999A",
  darkGrey: "#565556",
  darkBlue: "#0F52BA",
  lightBlue: "#D4E2F2",
  lightBorder: "#e1e1e1",
  primaryLight: "#7b8c9e",
  disabled: "#F0F0F0",
  error: "#f32a00",
  facebook: "#1877f2",
  green: "#00ba01",
  orange: "#FCF1DC",
  purple: "#81459B",
  lightPurple: "#C283DA",
  transparentPurple: "#9C27B01A",
  PrimaryPurple: "#9B5AF8",
  PrimaryPurple100: "#EFE9FE",
  PrimaryPurple500: "#9B5AF8",
  PrimaryPurple300: "#CBB4FE",
  PrimaryPurple700: "#8126DB",
  PrimaryPurple800: "#6C1FB8",
  PrimaryPurple400: "rgba(170, 124, 251, 1)",
  PrimaryPurple900: "rgba(90, 27, 151, 1)",
  PrimaryPurple600: "rgba(143, 56, 239, 1)",
  purpleGradient: "#9B5AF8B5",
  LightGreenBackground: "#E8F8EB",
  PrimaryGreen: "#26A840",
  TimedWheel: "#FFFBED",
  StrokePrimary: "#667085",
  divider: "rgba(187, 187, 187, 1)",
  NeutralBackground: "rgba(246, 247, 249, 1)",
  Education: "rgba(41, 193, 140, 1)",
  TimedWheelColor: "rgba(196, 221, 129, 1)",
  Highlight: "rgba(239, 233, 254, 1)",
  yellowDark:"#F5CC3B",
  yellowLight:"#FFFBED",
  textBlue: "#123051",
  NeutralBorder: "#BBBBBB",
  yellowText: "#F79A00",
  yellowLighter: "#FFF4E3",
  purpleLighter: "#F5DAF7",
  purpleText: "#99439D",
  greenLighter: "#D6FEF0",
  greenText: "#29C18C"
};

export const Muitheme = createTheme({
  palette: {
    primary: {
      main: colors.PrimaryPurple, // or any other color from your palette
      light: colors.PrimaryPurple300,
      dark: colors.PrimaryPurple700,
    },
    secondary: {
      main: colors.secondary,
    },
    background: {
      default: colors.background,
      paper: colors.white,
    },
    text: {
      primary: colors.black,
      secondary: colors.textSecondary,
    },
  },
});
